import { Injectable } from '@angular/core';

@Injectable()
export class MyLeadRouteGenerator {

  generate(leadId: string): string {
    return `/mylead/${btoa(JSON.stringify([leadId]))}`;
  }

  generateWithCompany(leadId: string, companyId: string): string {
    return `/mylead/${btoa(JSON.stringify([leadId, companyId]))}`;
  }

  generateWithShortId(shortId: string) {
    return `/lv/${shortId}`;
  }
}
